import User from "@/store/models/user";
import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";


export class NameserverZone extends Model {

  static entity = 'nameserver_zone'
  static apiEntity = 'zones'
  static primaryKey = 'name'

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      nameUnicode: this.string(''),

      serial: this.string(''),
      //BEARBEITUNG
      hostmaster: this.string(''),

      refresh: this.string(''),
      retry: this.string(''),
      expire: this.string(''),
      ttl: this.string(''),

      ns_first: this.string(''),
      ns_second: this.string(''),

      records: this.attr(null),
      //END BEARBEITUNG
      created_at: this.attr(null),
      updated_at: this.attr(null),

      username: this.attr(null),
      user: this.belongsTo(User, 'username')
    }
  }

  static async fetch(name) {
    if (!name) return
    const response = await axios.get('/dns/zones/show', {
      params: {
        zone: name
      }
    })
    NameserverZone.insertOrUpdate({data:response.data.zone})
    return NameserverZone.find(name)

  }
}

export default NameserverZone



// WEBPACK FOOTER //
// ./src/store/models/dns/nameserver_zone.js